// Module
var code = "60 seconds to complete your Powered Now account\n";
// Exports
module.exports = code;